export default __webpack_public_path__ + "img/bg_conference-fa3572be82986436c767c457e5a21bad.png";